import { chain } from "lodash"

export const constraints = [{
  name: "Max Concentration",
  id: "maxConcentration", // use the graphQL id
  type: "constraint",
}]

export function getConstraintRule(custom) {
  const rule = {
    name: chain(constraints).find(({ id }) => id === custom.id).get("name").value(),
  }
  switch (custom.id) {
    case "maxConcentration":
      rule.min = null
      rule.max = custom.max / 100
      rule.maxOnly = true
      rule.unit = "%"
  }
  return rule
}
